/* TODO: t() */
import { isValidEmail } from '../../../../core/support/isValidEmail';

const NUMERIC_REGEX = /^\d+$/;
const DATE_REGEX = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
const TIME_REGEX_24H = /^\d{1,2}:\d{2}$/;
const TIME_REGEX_12H = /^\d{1,2}:\d{2}(am|pm)$/i;

type ValidationError = string;

export const TYPE_NUMERIC = 'Numeric';
export const TYPE_DATE_USA = 'Date_USA';
export const TYPE_DATE_INTL = 'Date_Intl';
export const TYPE_TIME_24H = 'Time_24h';
export const TYPE_TIME_12H = 'Time_12h';
export const TYPE_EMAIL = 'Email';

export const DATE_TYPES = [TYPE_DATE_USA, TYPE_DATE_INTL];

export const ALL_TYPES = [
  TYPE_NUMERIC,
  ...DATE_TYPES,
  TYPE_TIME_24H,
  TYPE_TIME_12H,
  TYPE_EMAIL,
];

const nameByType: ObjectOf<string> = {
  [TYPE_NUMERIC]: 'Numeric Characters',
  [TYPE_DATE_USA]: 'US Date (MM/DD/YYYY)',
  [TYPE_DATE_INTL]: 'Intl Date (DD/MM/YYYY)',
  [TYPE_TIME_24H]: '24hr Time',
  [TYPE_TIME_12H]: 'AM/PM Time',
  [TYPE_EMAIL]: 'Email Address',
};

const placeholderByType: ObjectOf<string> = {
  [TYPE_NUMERIC]: 'Enter numeric characters',
  [TYPE_DATE_USA]: 'Enter date as MM/DD/YYYY',
  [TYPE_DATE_INTL]: 'Enter date as DD/MM/YYYY',
  [TYPE_TIME_24H]: 'Enter time such as 16:41',
  [TYPE_TIME_12H]: 'Enter time such as 11:41am',
  [TYPE_EMAIL]: 'Enter an email such as me@example.com',
};

const validationErrorByType: ObjectOf<string> = {
  [TYPE_NUMERIC]: 'Enter numeric characters',
  [TYPE_DATE_USA]: 'Enter date as MM/DD/YYYY',
  [TYPE_DATE_INTL]: 'Enter date as DD/MM/YYYY',
  [TYPE_TIME_24H]: 'Enter time such as 16:41',
  [TYPE_TIME_12H]: 'Enter time such as 11:41am',
  [TYPE_EMAIL]: 'Enter an email such as me@example.com',
};

const defaultValidationError = 'Please complete this field';

type Validator = (value: string) => boolean;

const validationByType: ObjectOf<Validator> = {
  [TYPE_NUMERIC]: (value) => NUMERIC_REGEX.test(value),
  [TYPE_DATE_USA]: (value) => DATE_REGEX.test(value),
  [TYPE_DATE_INTL]: (value) => DATE_REGEX.test(value),
  [TYPE_TIME_24H]: (value) => TIME_REGEX_24H.test(value),
  [TYPE_TIME_12H]: (value) => TIME_REGEX_12H.test(value),
  [TYPE_EMAIL]: (value) => isValidEmail(value),
};

export function getName(validationType: string | null | undefined): string {
  return (validationType && nameByType[validationType]) || '';
}

export function getPlaceholder(
  validationType: string | null | undefined,
): string {
  return (validationType && placeholderByType[validationType]) || '';
}

export function validateInput(
  validationType: string | null | undefined,
  value: string,
): ValidationError | null | undefined {
  let validator =
    validationType && value !== '' ? validationByType[validationType] : null;
  if (validator) {
    let isValid = validator(value);
    if (!isValid) {
      return (
        (validationType && validationErrorByType[validationType]) ||
        defaultValidationError
      );
    }
  }
}

export function validateRealTime(
  validationType: string | null | undefined,
  value: string,
): string {
  switch (validationType) {
    case TYPE_NUMERIC: {
      return value.replace(/\D/g, '');
    }
    default: {
      return value;
    }
  }
}
